import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconEditLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 19h1.261L16.498 8.764l-1.262-1.262L5 17.738V19Zm-.596 1.5a.874.874 0 0 1-.644-.26.874.874 0 0 1-.26-.644v-1.733a1.8 1.8 0 0 1 .527-1.275L16.69 3.931a1.71 1.71 0 0 1 .501-.319 1.5 1.5 0 0 1 .575-.112c.2 0 .395.036.583.107.188.07.354.184.499.34l1.221 1.236c.155.145.266.311.332.5.066.188.099.377.099.565 0 .201-.034.393-.103.576-.069.183-.178.35-.328.501L7.412 19.973a1.8 1.8 0 0 1-1.276.527H4.404ZM15.856 8.144l-.62-.642 1.262 1.262-.642-.62Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEditLine;
